[
  {
    "id": "bus_depot_handoff",
    "n": 1,
    "title": "Terminal Handoff",
    "type": "transport",
    "typeIconId": "contracts.icons.type_transport",
    "sceneId": "contracts.scenes.bus_depot_handoff",
    "sponsorName": "Leo Furlong",
    "sponsorArtId": "contracts.sponsors.bail_bond_magnate",
    "sealId": "contracts.seals.anchor_chain_ring",
    "dossierId": "contracts.dossier_blank",
    "risk": "low",
    "nerve": 3,
    "brief": "A locker key changes hands in the Kepler concourse. You never touch the bag."
  },
  {
    "id": "ferry_handoff",
    "n": 2,
    "title": "Ferry Handoff",
    "type": "transport",
    "typeIconId": "contracts.icons.type_transport",
    "sceneId": "contracts.scenes.ferry_handoff",
    "sponsorName": "M. Vandergrift",
    "sponsorArtId": "contracts.sponsors.bank_vice_chair",
    "sealId": "contracts.seals.bell_laurel_ring",
    "dossierId": "contracts.dossier_fresh",
    "risk": "medium",
    "nerve": 5,
    "brief": "Stern deck, mid-crossing, one hawser coil and eleven minutes of open water."
  },
  {
    "id": "safe_move",
    "n": 3,
    "title": "The Safe Move",
    "type": "transport",
    "typeIconId": "contracts.icons.type_transport",
    "sceneId": "contracts.scenes.safe_move",
    "sponsorName": "Howard Louie",
    "sponsorArtId": "contracts.sponsors.funeral_home_dynast",
    "sealId": "contracts.seals.bridge_arch",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "high",
    "nerve": 7,
    "brief": "A cast-iron floor safe on a hand truck, at the top of four steps, at two in the morning."
  },
  {
    "id": "tow_lot_recovery",
    "n": 4,
    "title": "The Tow Lot",
    "type": "transport",
    "typeIconId": "contracts.icons.type_transport",
    "sceneId": "contracts.scenes.tow_lot_recovery",
    "sponsorName": "Leo Furlong",
    "sponsorArtId": "contracts.sponsors.bail_bond_magnate",
    "sealId": "contracts.seals.compass_rose",
    "dossierId": "contracts.dossier_weathered",
    "risk": "medium",
    "nerve": 5,
    "brief": "A car in impound with something in the trunk that has to come out before the inventory."
  },
  {
    "id": "dead_drop",
    "n": 5,
    "title": "Dead Drop",
    "type": "transport",
    "typeIconId": "contracts.icons.type_transport",
    "sceneId": "contracts.scenes.dead_drop",
    "sponsorName": "Howard Louie",
    "sponsorArtId": "contracts.sponsors.funeral_home_dynast",
    "sealId": "contracts.seals.crossed_keys_diamond",
    "dossierId": "contracts.dossier_blank",
    "risk": "low",
    "nerve": 3,
    "brief": "Under a slatted bench in a pocket park. Six minutes early and you have already failed."
  },
  {
    "id": "funeral_watch",
    "n": 6,
    "title": "Funeral Watch",
    "type": "protection",
    "typeIconId": "contracts.icons.type_protection",
    "sceneId": "contracts.scenes.funeral_watch",
    "sponsorName": "Odessa Pruitt",
    "sponsorArtId": "contracts.sponsors.judge_emeritus",
    "sealId": "contracts.seals.foundry_gear_flame",
    "dossierId": "contracts.dossier_fresh",
    "risk": "medium",
    "nerve": 5,
    "brief": "Somebody attends the service. Somebody else attends from a car across the street."
  },
  {
    "id": "hospital_visit",
    "n": 7,
    "title": "Hospital Visit",
    "type": "protection",
    "typeIconId": "contracts.icons.type_protection",
    "sceneId": "contracts.scenes.hospital_visit",
    "sponsorName": "E. Prendergast",
    "sponsorArtId": "contracts.sponsors.numbers_matriarch",
    "sealId": "contracts.seals.harbor_beacon",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "medium",
    "nerve": 4,
    "brief": "A corridor at night, a room number, and nobody goes in it who is not on the list."
  },
  {
    "id": "witness_relocation",
    "n": 8,
    "title": "Relocation",
    "type": "protection",
    "typeIconId": "contracts.icons.type_protection",
    "sceneId": "contracts.scenes.witness_relocation",
    "sponsorName": "Judge Weathersby",
    "sponsorArtId": "contracts.sponsors.parish_benefactor",
    "sealId": "contracts.seals.keystone_shield",
    "dossierId": "contracts.dossier_weathered",
    "risk": "high",
    "nerve": 8,
    "brief": "A wood-panelled wagon idling before dawn with the tailgate up. One passenger, no luggage."
  },
  {
    "id": "docks_do_not_sleep",
    "n": 9,
    "title": "Do Not Sleep",
    "type": "protection",
    "typeIconId": "contracts.icons.type_protection",
    "sceneId": "contracts.scenes.docks_do_not_sleep",
    "sponsorName": "M. Vandergrift",
    "sponsorArtId": "contracts.sponsors.bank_vice_chair",
    "sealId": "contracts.seals.rail_spike_star",
    "dossierId": "contracts.dossier_blank",
    "risk": "high",
    "nerve": 7,
    "brief": "Three in the morning between two stacks. Nothing happens. That is the job."
  },
  {
    "id": "bar_backroom_sitdown",
    "n": 10,
    "title": "Backroom Sitdown",
    "type": "protection",
    "typeIconId": "contracts.icons.type_protection",
    "sceneId": "contracts.scenes.bar_backroom_sitdown",
    "sponsorName": "Packy Coughlin",
    "sponsorArtId": "contracts.sponsors.scrapyard_baron",
    "sealId": "contracts.seals.rivet_hexagon",
    "dossierId": "contracts.dossier_fresh",
    "risk": "medium",
    "nerve": 5,
    "brief": "Two crews, one bead curtain, and you are the reason it stays a conversation."
  },
  {
    "id": "shakedown",
    "n": 11,
    "title": "The Stockroom",
    "type": "extortion",
    "typeIconId": "contracts.icons.type_extortion",
    "sceneId": "contracts.scenes.shakedown",
    "sponsorName": "Packy Coughlin",
    "sponsorArtId": "contracts.sponsors.scrapyard_baron",
    "sealId": "contracts.seals.scales_octagon",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "low",
    "nerve": 3,
    "brief": "Dented cans on both sides, a man between them, and a number that goes up on Friday."
  },
  {
    "id": "harbormaster_bribe",
    "n": 12,
    "title": "The Harbormaster",
    "type": "extortion",
    "typeIconId": "contracts.icons.type_extortion",
    "sceneId": "contracts.scenes.harbormaster_bribe",
    "sponsorName": "M. Vandergrift",
    "sponsorArtId": "contracts.sponsors.bank_vice_chair",
    "sealId": "contracts.seals.tide_chevrons",
    "dossierId": "contracts.dossier_weathered",
    "risk": "medium",
    "nerve": 5,
    "brief": "A brick tower with windows on three sides. He decides what enters the channel."
  },
  {
    "id": "judges_driveway",
    "n": 13,
    "title": "The Driveway",
    "type": "extortion",
    "typeIconId": "contracts.icons.type_extortion",
    "sceneId": "contracts.scenes.judges_driveway",
    "sponsorName": "Packy Coughlin",
    "sponsorArtId": "contracts.sponsors.scrapyard_baron",
    "sealId": "contracts.seals.anchor_chain_ring",
    "dossierId": "contracts.dossier_blank",
    "risk": "extreme",
    "nerve": 10,
    "brief": "Brick colonials, clipped hedges, before dawn. There is no version of this that is quiet."
  },
  {
    "id": "union_vote_fix",
    "n": 14,
    "title": "The Vote",
    "type": "extortion",
    "typeIconId": "contracts.icons.type_extortion",
    "sceneId": "contracts.scenes.union_vote_fix",
    "sponsorName": "Ziggy Baran",
    "sponsorArtId": "contracts.sponsors.shipping_heiress",
    "sealId": "contracts.seals.bell_laurel_ring",
    "dossierId": "contracts.dossier_fresh",
    "risk": "high",
    "nerve": 7,
    "brief": "The hall after the meeting, chairs askew, and a count that has to come out one way."
  },
  {
    "id": "jury_approach",
    "n": 15,
    "title": "Jury Approach",
    "type": "extortion",
    "typeIconId": "contracts.icons.type_extortion",
    "sceneId": "contracts.scenes.jury_approach",
    "sponsorName": "Judge Weathersby",
    "sponsorArtId": "contracts.sponsors.parish_benefactor",
    "sealId": "contracts.seals.bridge_arch",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "extreme",
    "nerve": 11,
    "brief": "Courthouse steps at dusk, from across the street, through a 135. Then closer."
  },
  {
    "id": "boiler_room_burn",
    "n": 16,
    "title": "The Boiler Room",
    "type": "sabotage",
    "typeIconId": "contracts.icons.type_sabotage",
    "sceneId": "contracts.scenes.boiler_room_burn",
    "sponsorName": "Elpidio Nazario",
    "sponsorArtId": "contracts.sponsors.state_senator",
    "sealId": "contracts.seals.compass_rose",
    "dossierId": "contracts.dossier_weathered",
    "risk": "high",
    "nerve": 7,
    "brief": "A firebox door swung open in a sub-basement, and a building above it full of paper."
  },
  {
    "id": "warehouse_torch",
    "n": 17,
    "title": "Warehouse Torch",
    "type": "sabotage",
    "typeIconId": "contracts.icons.type_sabotage",
    "sceneId": "contracts.scenes.warehouse_torch",
    "sponsorName": "Stavros Manolis",
    "sponsorArtId": "contracts.sponsors.teamster_boss",
    "sealId": "contracts.seals.crossed_keys_diamond",
    "dossierId": "contracts.dossier_blank",
    "risk": "high",
    "nerve": 8,
    "brief": "Roof trusses vanishing into blackness. Mulcahy does the work. You do the alibi."
  },
  {
    "id": "wire_removal",
    "n": 18,
    "title": "Wire Removal",
    "type": "sabotage",
    "typeIconId": "contracts.icons.type_sabotage",
    "sceneId": "contracts.scenes.wire_removal",
    "sponsorName": "Stavros Manolis",
    "sponsorArtId": "contracts.sponsors.teamster_boss",
    "sealId": "contracts.seals.foundry_gear_flame",
    "dossierId": "contracts.dossier_fresh",
    "risk": "medium",
    "nerve": 5,
    "brief": "Cracked subway tile and a spotted mirror, and something behind the mirror."
  },
  {
    "id": "printing_run",
    "n": 19,
    "title": "The Print Run",
    "type": "sabotage",
    "typeIconId": "contracts.icons.type_sabotage",
    "sceneId": "contracts.scenes.printing_run",
    "sponsorName": "Ziggy Baran",
    "sponsorArtId": "contracts.sponsors.shipping_heiress",
    "sealId": "contracts.seals.harbor_beacon",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "medium",
    "nerve": 5,
    "brief": "A green cast-iron press mid-run. The sheets coming off it are wrong on purpose."
  },
  {
    "id": "basement_count",
    "n": 20,
    "title": "Short Count",
    "type": "sabotage",
    "typeIconId": "contracts.icons.type_sabotage",
    "sceneId": "contracts.scenes.basement_count",
    "sponsorName": "Connie Ruffo",
    "sponsorArtId": "contracts.sponsors.union_president",
    "sealId": "contracts.seals.keystone_shield",
    "dossierId": "contracts.dossier_weathered",
    "risk": "high",
    "nerve": 7,
    "brief": "A whitewashed vaulted cellar and a count that has to come out eleven hundred light."
  },
  {
    "id": "courier_intercept",
    "n": 21,
    "title": "Courier Intercept",
    "type": "disruption",
    "typeIconId": "contracts.icons.type_disruption",
    "sceneId": "contracts.scenes.courier_intercept",
    "sponsorName": "Leo Furlong",
    "sponsorArtId": "contracts.sponsors.bail_bond_magnate",
    "sealId": "contracts.seals.rail_spike_star",
    "dossierId": "contracts.dossier_blank",
    "risk": "medium",
    "nerve": 5,
    "brief": "Level three, low ceiling, cropped columns. Ninety seconds either side of four."
  },
  {
    "id": "tail_a_courier",
    "n": 22,
    "title": "Tail a Courier",
    "type": "disruption",
    "typeIconId": "contracts.icons.type_disruption",
    "sceneId": "contracts.scenes.tail_a_courier",
    "sponsorName": "Sen. Auerbach",
    "sponsorArtId": "contracts.sponsors.ward_boss",
    "sealId": "contracts.seals.rivet_hexagon",
    "dossierId": "contracts.dossier_fresh",
    "risk": "low",
    "nerve": 3,
    "brief": "Gloved hands at ten and two, a cigarette going, and four cars of separation."
  },
  {
    "id": "evidence_swap",
    "n": 23,
    "title": "Evidence Swap",
    "type": "disruption",
    "typeIconId": "contracts.icons.type_disruption",
    "sceneId": "contracts.scenes.evidence_swap",
    "sponsorName": "Judge Weathersby",
    "sponsorArtId": "contracts.sponsors.parish_benefactor",
    "sealId": "contracts.seals.scales_octagon",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "extreme",
    "nerve": 12,
    "brief": "Caged steel shelving, sealed paper bags, and one bag that has to become a different bag."
  },
  {
    "id": "phone_booth_call",
    "n": 24,
    "title": "The Booth",
    "type": "disruption",
    "typeIconId": "contracts.icons.type_disruption",
    "sceneId": "contracts.scenes.phone_booth_call",
    "sponsorName": "Connie Ruffo",
    "sponsorArtId": "contracts.sponsors.union_president",
    "sealId": "contracts.seals.tide_chevrons",
    "dossierId": "contracts.dossier_weathered",
    "risk": "low",
    "nerve": 2,
    "brief": "Aluminium and glass on a cracked sidewalk. One call, ninety seconds, and then walk."
  },
  {
    "id": "books_cooking",
    "n": 25,
    "title": "Cooking the Books",
    "type": "disruption",
    "typeIconId": "contracts.icons.type_disruption",
    "sceneId": "contracts.scenes.books_cooking",
    "sponsorName": "Connie Ruffo",
    "sponsorArtId": "contracts.sponsors.union_president",
    "sealId": "contracts.seals.anchor_chain_ring",
    "dossierId": "contracts.dossier_blank",
    "risk": "medium",
    "nerve": 4,
    "brief": "Shirtsleeves and elastic armbands over an adding machine, and a tape that will be read."
  },
  {
    "id": "silence_the_informant",
    "n": 26,
    "title": "The Informant",
    "type": "elimination",
    "typeIconId": "contracts.icons.type_elimination",
    "sceneId": "contracts.scenes.silence_the_informant",
    "sponsorName": "E. Prendergast",
    "sponsorArtId": "contracts.sponsors.numbers_matriarch",
    "sealId": "contracts.seals.bell_laurel_ring",
    "dossierId": "contracts.dossier_fresh",
    "risk": "extreme",
    "nerve": 12,
    "brief": "An all-night diner, from behind the counter, past a chrome pie case. Ricky Albano."
  },
  {
    "id": "rooftop_signal",
    "n": 27,
    "title": "Rooftop Signal",
    "type": "elimination",
    "typeIconId": "contracts.icons.type_elimination",
    "sceneId": "contracts.scenes.rooftop_signal",
    "sponsorName": "Elpidio Nazario",
    "sponsorArtId": "contracts.sponsors.state_senator",
    "sealId": "contracts.seals.bridge_arch",
    "dossierId": "contracts.dossier_water_damaged",
    "risk": "high",
    "nerve": 9,
    "brief": "Tar and gravel, and a light that goes on twice to mean yes and once to mean go home."
  },
  {
    "id": "church_confessional_meet",
    "n": 28,
    "title": "The Confessional",
    "type": "elimination",
    "typeIconId": "contracts.icons.type_elimination",
    "sceneId": "contracts.scenes.church_confessional_meet",
    "sponsorName": "Odessa Pruitt",
    "sponsorArtId": "contracts.sponsors.judge_emeritus",
    "sealId": "contracts.seals.compass_rose",
    "dossierId": "contracts.dossier_weathered",
    "risk": "high",
    "nerve": 8,
    "brief": "Empty pews receding into blue gloom. Two men who both know why they are here."
  },
  {
    "id": "motel_stakeout",
    "n": 29,
    "title": "Motel Stakeout",
    "type": "elimination",
    "typeIconId": "contracts.icons.type_elimination",
    "sceneId": "contracts.scenes.motel_stakeout",
    "sponsorName": "Sen. Auerbach",
    "sponsorArtId": "contracts.sponsors.ward_boss",
    "sealId": "contracts.seals.crossed_keys_diamond",
    "dossierId": "contracts.dossier_blank",
    "risk": "high",
    "nerve": 9,
    "brief": "A 35mm on a tripod at a gap in heavy curtains, cable release swinging."
  },
  {
    "id": "garage_meet",
    "n": 30,
    "title": "The Garage",
    "type": "elimination",
    "typeIconId": "contracts.icons.type_elimination",
    "sceneId": "contracts.scenes.garage_meet",
    "sponsorName": "Ziggy Baran",
    "sponsorArtId": "contracts.sponsors.shipping_heiress",
    "sealId": "contracts.seals.foundry_gear_flame",
    "dossierId": "contracts.dossier_fresh",
    "risk": "high",
    "nerve": 8,
    "brief": "A sedan chest-high on a post lift, and a conversation underneath it."
  }
]
